import React from 'react';
import { Interpolation, Theme } from '@core-ui/react-stitch';
import { useLocalize } from '@core-ui/localization-provider';
import { InlineFacetTagProps } from '../../types';

const facetLocalizationKeys = {
  reviewScore: 'facet_reference.facet_label_rating',
  allReviewedProducts: 'left_hand_facet_rating.rating_facet_all_reviewed',
};

const inlineFacetTagStyles = (
  capitalized: boolean,
  theme: Theme
): Interpolation<Theme> => ({
  '&:hover': {
    boxShadow: `inset 0 0 0 1px ${theme.color.gray80}`,
  },
  ...theme.brandFont,
  display: 'inline-flex',
  margin: '.35rem .75rem .35rem 0',
  background: theme.color.gray05,
  borderRadius: '1rem',
  lineHeight: '.75rem',
  alignItems: 'center',
  pointerEvents: 'none',
  ...(capitalized ? { textTransform: 'capitalize' } : {}),
});

const inlineFacetTagTextDisplayStyles = (
  theme: Theme
): Interpolation<Theme> => ({
  fontSize: '.875rem',
  color: theme.color.gray80,
  paddingLeft: '1rem',
  paddingBottom: theme.brand === 'at' ? '4px' : 0,
});

const inlineFacetTagIconXStyles = (theme: Theme): Interpolation<Theme> => ({
  pointerEvents: 'auto',
  fontSize: '.875rem',
  padding: '.25rem .5rem',
  border: 'none',
  background: 'transparent',
  display: 'inline-flex',
  path: {
    stroke: theme.color.b1,
  },
});

const InlineFacetTag = (props: InlineFacetTagProps) => {
  const {
    id,
    name,
    onClear,
    ariaLabel,
    displayName,
    facetName,
    capitalizedText,
  } = props;

  const onClick = () => onClear({ id, name, facetName, applied: false });
  const arialLabel = `${ariaLabel}: ${displayName}`;
  const { localize } = useLocalize();
  const getReviewScoreDisplayString = () => {
    const specificReviewScore = `${localize(
      facetLocalizationKeys.reviewScore
    )}: ${displayName}`;
    const anyReviewScore = localize(facetLocalizationKeys.allReviewedProducts);
    return displayName.indexOf('1') === 0
      ? anyReviewScore
      : specificReviewScore;
  };
  const localizedDisplayName =
    facetName === 'reviewScore' ? getReviewScoreDisplayString() : displayName;

  return (
    <div css={(theme) => inlineFacetTagStyles(capitalizedText, theme)}>
      <span css={inlineFacetTagTextDisplayStyles}>{localizedDisplayName}</span>
      <button
        aria-label={arialLabel}
        css={inlineFacetTagIconXStyles}
        onClick={onClick}
        type="button"
      >
        <svg
          height="16px"
          viewBox="0 0 16 16"
          width="16px"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g
            fill="none"
            fillRule="evenodd"
            stroke="none"
            strokeLinecap="round"
            strokeWidth="1"
          >
            <path
              d="M8,8 L12.5,3.5 L8,8 L3.5,3.5 L8,8 L8,8 Z M8,8 L12.5,12.5 L8,8 L3.5,12.5 L8,8 L8,8 Z"
              id="Shape"
              stroke="#000000"
              strokeWidth="1.5"
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

export default InlineFacetTag;
